import * as React from 'react';

import { MultilineTotal } from './components/MultilineTotal';
import { useMultilineTotalContainer } from './hooks';

export const MultilineTotalContainer = () => {
  const props = useMultilineTotalContainer();

  if (!props.isVisible) {
    return null;
  }

  return <MultilineTotal {...props} />;
};
